/** Substring candidates in original order, preserving the legacy first-match policy. */
export function createProfessorLookup<T extends { firstName: string; lastName: string }>(records: readonly T[]) {
  const normalized = records.map((record) => ({ first: record.firstName.toLowerCase(), last: record.lastName.toLowerCase() }));
  const postings = new Map<string, number[]>();
  const all = records.map((_, index) => index);
  normalized.forEach(({ last }, index) => {
    const grams = new Set<string>();
    for (let size = 1; size <= 3; size++) {
      for (let start = 0; start <= last.length - size; start++) grams.add(last.slice(start, start + size));
    }
    for (const gram of grams) {
      const entries = postings.get(gram);
      if (entries) entries.push(index);
      else postings.set(gram, [index]);
    }
  });
  return (firstName: string | null, lastName: string): T | undefined => {
    const first = firstName?.toLowerCase();
    const last = lastName.toLowerCase();
    let candidates = all;
    const size = Math.min(3, last.length);
    if (size) {
      for (let start = 0; start <= last.length - size; start++) {
        const entries = postings.get(last.slice(start, start + size));
        if (!entries) return undefined;
        if (entries.length < candidates.length) candidates = entries;
      }
    }
    const full = first ? candidates.find((index) => normalized[index].last.includes(last) && normalized[index].first.includes(first)) : undefined;
    const index = full ?? candidates.find((index) => normalized[index].last.includes(last));
    return index === undefined ? undefined : records[index];
  };
}
